import { useSyncExternalStore } from "react";

export type ToastTone = "info" | "success" | "error";

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface Toast {
  id: number;
  message: string;
  tone: ToastTone;
  expiresAt: number;
  action?: ToastAction;
}

let nextId = 1;
let toasts: Toast[] = [];
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

function snapshot() {
  return toasts;
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function useToasts(): Toast[] {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}

export function showToast(
  message: string,
  tone: ToastTone = "info",
  durationMs = 2400,
  action?: ToastAction,
): number {
  const id = nextId++;
  toasts = [...toasts, { id, message, tone, expiresAt: Date.now() + durationMs, action }];
  emit();
  window.setTimeout(() => dismissToast(id), durationMs);
  return id;
}

export function dismissToast(id: number) {
  const before = toasts.length;
  toasts = toasts.filter((t) => t.id !== id);
  if (toasts.length !== before) emit();
}
